import * as React from 'react';
import { compose } from 'redux';

import Dropdown from 'af-components/Controls/Dropdown';

import styles from './styles.module.scss';

export interface DepartmentFilterOption {
	id: number;
	label: string;
}

interface OwnProps {
	onChange: (option: Nullable<DepartmentFilterOption>) => void;
	options: DepartmentFilterOption[];
}

type Props = OwnProps;

const DepartmentFilter: React.FC<Props> = (props) => {

	const {
		onChange,
		options,
	} = props;

	const renderOption = React.useCallback((option: DepartmentFilterOption) => {
		return (
			<>
				{option.label}
			</>
		);
	}, []);

	const filterBy = React.useCallback((option: DepartmentFilterOption, rawInput: string) => {
		return option.label.toLowerCase().includes(rawInput.toLowerCase());
	}, []);

	return (
		<div className={styles.dropdown}>
			<Dropdown<DepartmentFilterOption>
				filterable={true}
				filterBy={filterBy}
				hasBlankOption={true}
				labelKey={'label'}
				onValueChange={onChange}
				options={options}
				placeholder="Select Department"
				renderMenuItem={renderOption}
				valueKey={'id'}
				withCaret={true}
			/>
		</div>
	);
};

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo
);

export default enhance(DepartmentFilter);
